<div class="hostWrapper">
  <div
    class="wrapper"
    [class.borderBottom]="
      !lastLoad || (cargoSpaceIndex === 0 && project.workSpaces[workSpaceIndex].cargoSpaces[1])
    "
    [class.mobile]="isMobile"
    >
    <div class="container">
      <div class="description">
        @if (group.destination) {
          <img [src]="generatedImage" />
        }
        @if (!group.destination) {
          <div
            class="groupColor"
            [ngStyle]="{ 'background-color': getColor() }"
          ></div>
        }
        <div>
          <div class="groupName" data-ctx="label-group-name">
            {{ group.name | translate }}
          </div>
          @if (group.loadType === 0 || group.loadType === 3) {
            <p data-ctx="container-dimensions" class="dimensions">
              {{ group.dimensions.length }} x {{ group.dimensions.width }} x
              {{ group.dimensions.height | unit: 'length':false }} |
              {{ group.weight | unit: 'weight':false }}
            </p>
          }
          @if (group.loadType === 1) {
            <p data-ctx="container-dimensions" class="dimensions">
              {{ group.dimensions.height | unit: 'length':false }} x {{ group.dimensions.diameter }} |
              {{ group.weight | unit: 'weight':false }}
            </p>
          }
          @if (group.loadType === 2) {
            <p data-ctx="container-dimensions" class="dimensions">
              {{ group.dimensions.length | unit: 'length':false }} x {{ group.dimensions.diameter }} |
              {{ group.weight | unit: 'weight':false }}
            </p>
          }
        </div>
      </div>
      <div class="more-container">
        @if (isLoadNotDisplayed()) {
          <div class="error-icon" [glTooltip]="'load_not_displayed'">
            i
          </div>
        }
        @if (!isMobile) {
          <div class="edit" [class.drag-disabled]="interactionDisabled">
            @if (!interactionDisabled) {
              <span data-ctx="button-minus" #minus>-</span>
              <div
                [glTooltip]="'replicated_pallet_loads_hint'"
                [disableTooltip]="!showReplicatedLoadHint()"
                [position]="'bottom'"
                [width]="'280px'"
              >{{ loadQuantityLabel() }}</div>
              <span #plus>+</span>
              @if (!isUnloadingSpace) {
                <button icon-button (click)="editGroup()" #editTrigger>
                  <gl-icon class="moreIcon" [name]="'more'" data-ctx="button-edit-group"></gl-icon>
                </button>
              }
            } @else {
              <div
                [glTooltip]="'replicated_pallet_loads_hint'"
                [disableTooltip]="!showReplicatedLoadHint()"
                [position]="'bottom'"
                [width]="'280px'"
              >{{ loadQuantityLabel() }}</div>
            }
          </div>
        }
      </div>
      @if (isMobile || isSharedView) {
        <div class="quantity">
          <div
            [glTooltip]="'replicated_pallet_loads_hint'"
            [disableTooltip]="!showReplicatedLoadHint()"
            [position]="'bottom'"
            [width]="'280px'"
          >{{ loadQuantityLabel() }}</div>
        </div>
      }
    </div>
  </div>
</div>

@if (edit) {
  <gl-loads-list-element-edit
    glMousedownOutside
    (glMousedownOutside)="editGroup()"
    [elementToIgnore]="editTriggerEl"
    #edit
    [group]="group"
    (closeComponent)="onClose()"
    [isOutsideSpace]="isOutsideSpace"
    [workSpaceIndex]="workSpaceIndex"
    [stopIndex]="stopIndex"
    [cargoSpaceIndex]="cargoSpaceIndex"
  ></gl-loads-list-element-edit>
}
